import React, { Component } from 'react';
import { Form } from 'react-bootstrap';

class QuizinatorSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ans: null,
            cont: false
        };

        this.handleClick = this.handleClick.bind(this);
    }
    render() {
        let quiz = this.props.quiz,
            question = this.props.quiz.questions[this.props.currentQuestionIndex],
            htmlQuestion = function () {
                return { __html: question.question };
            },
            answerOptions = question.answers.map((answer, i) =>
                <option key={`sel_${i}_${question.id || ''}`} value={`${i}|${answer}`}>{answer}</option>
        );

        return (
            <section className={'quizSection' + (this.props.buttonsDisabled ? ' transitionOut' : '')}>
                {this.props.introText &&
                    <div className="questionIntro">
                        <p>{this.props.introText}</p>
                    </div>
                }
                <div className="questionNumber">Question {this.props.currentQuestionIndex + 1} / {quiz.questions.length}</div>
                <div className="question">
                    <div dangerouslySetInnerHTML={htmlQuestion()} />
                </div>
                <div className="answers">
                    <Form.Control as="select" size="lg" 
                        onChange={(e) => {
                            let ans = e.target.value.split('|');
                            if(ans && ans.length > 0){
                                this.setState({ans: {v: ans[1], i: parseInt(ans[0])}, cont: true});
                            } else {
                                this.setState({ans: null, cont: false});
                            }                            
                        }}>
                        <option key='-1' value={{}}>Please select...</option>
                        {answerOptions}
                    </Form.Control>
                    <br/>
                    <button onClick={this.handleClick.bind(this)} className={(!this.state.cont)?'disabled':''} disabled={!this.state.cont}>Next</button>
                </div>
            </section>
        );
    }

    handleClick(event) {
        let { ans } = this.state;
        let answer = { value: ans.i },
            target = event.currentTarget;

        this.props.submitAnswer(answer);

        target.classList.add('clicked');

        let that = this;
        window.setTimeout(function () {
            target.classList.remove('clicked', 'correct', 'incorrect');

            that.setState({cont: false, ans: null});
        }, this.props.transitionDelay);
    }
}

export default QuizinatorSelect;